import { HostingModel, ServerModel } from '@/models'
import { ProductViewModel } from '@/view-models'

export class GroupViewModel extends ProductViewModel {
  makeModels(
    widget: HTMLElement,
    token: string
  ): [HostingModel | ServerModel, HTMLElement][] {
    const cardElements = widget.querySelectorAll<HTMLElement>(
      '.js-pricing-table .pricing'
    )
    return Array.from(cardElements).map((element) => [
      this.makeModel(element, token),
      element
    ])
  }

  isGroup(element: HTMLElement): boolean {
    return !!element.querySelector('input[name=gid]')
  }
}
